import type { ComponentProps, PropsWithChildren, ReactNode } from 'react';

type ModalContentProps = PropsWithChildren<ComponentProps<'div'>>;

/**
 * Wrapper for the modal content.
 *
 * @param root0 input props
 * @param root0.children the children to pass down
 * @returns wrapper for the modal content
 */
export default function ModalContent({ children, ...props }: ModalContentProps): ReactNode {
  return <div {...props}>{children}</div>;
}
